export default __webpack_public_path__ + "static/media/Group 3174@2x.221323fe.png";